import config from "@/config";

import { Api } from "./Api";
import { ApiResponse } from "./Model";

const TEALIUM_API = config.tealiumApi;
const TEALIUM_DATA_PATH = "/vdata/i.gif";

export enum TealiumGender {
  male = "1",
  female = "2",
  diverse = "3",
}

export enum TealiumIncomeRange {
  small = "1",
  medium = "2",
  large = "3",
  xtra_large = "4",
}

export enum TealiumAgeRange {
  young_adults = "1",
  adults = "2",
  middle_adults = "3",
  older_adults = "4",
  senior_adults = "5",
  young_old_plus = "6",
}

export type QuestionSet = {
  question: string;
  options: { value: string; text: string }[];
};

export type QuestionConfig = {
  gender: QuestionSet;
  income_range: QuestionSet;
  age_range: QuestionSet;
};

export const QuestionConfigData: QuestionConfig = {
  gender: {
    question: "Welches Geschlecht haben Sie?",
    options: [
      {
        value: TealiumGender.female,
        text: "WEIBLICH",
      },
      {
        value: TealiumGender.male,
        text: "MÄNNLICH",
      },
      {
        value: TealiumGender.diverse,
        text: "DIVERS",
      },
    ],
  },
  income_range: {
    question: "Welches Jahreseinkommen haben Sie?",
    options: [
      {
        value: TealiumIncomeRange.small,
        text: "0 – 30.000€",
      },
      {
        value: TealiumIncomeRange.medium,
        text: "30.000 – 60.000€",
      },
      {
        value: TealiumIncomeRange.large,
        text: "60.000 – 100.000€",
      },
      {
        value: TealiumIncomeRange.xtra_large,
        text: "100.000€+",
      },
    ],
  },
  age_range: {
    question: "Welches Alter haben Sie?",
    options: [
      {
        value: TealiumAgeRange.young_adults,
        text: "18 – 19",
      },
      {
        value: TealiumAgeRange.adults,
        text: "20 – 29",
      },
      {
        value: TealiumAgeRange.middle_adults,
        text: "30 – 39",
      },
      {
        value: TealiumAgeRange.older_adults,
        text: "40 – 49",
      },
      {
        value: TealiumAgeRange.senior_adults,
        text: "50 – 59",
      },
      {
        value: TealiumAgeRange.young_old_plus,
        text: "60 +",
      },
    ],
  },
};

export interface TealiumApi {
  send(query: ITealium): Promise<ApiResponse<void>>;
}

export class TealiumApiService implements TealiumApi {
  private api: Api;

  public constructor(host: string = TEALIUM_API) {
    this.api = new Api(host);
  }

  public send(query: object | undefined): Promise<ApiResponse<void>> {
    return this.api.get(TEALIUM_DATA_PATH, query);
  }
}
